export default "__VITE_ASSET__f3FaURFT__"